import { render } from "./Project.vue?vue&type=template&id=9221f214"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"

import "./Project.vue?vue&type=style&index=0&id=9221f214&lang=scss"
script.render = render

export default script